import { FC } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Notifications } from "@/components";
import styles from "./NotificationsPage.module.scss";


export const NotificationsPage: FC = () => {

  return (
    <div className={styles.NotificationPanelContainer}>
      <Stack spacing="large">
        <Notifications />
      </Stack>
    </div>
  );
};

export default NotificationsPage;
